export default function formValidationController($scope, $http) {

    $scope.init = function() {
        $scope.formData = {};
    }

    $scope.init();

    $scope.submitForm = function($event) {
        $event.preventDefault();
        $scope.formData.nodeId = document.getElementsByTagName('form')[0].getAttribute('data-node');

        $http({
                method: 'POST',
                url: '/webapi/programenquiry/enquiriesformajax',
                data: $.param($scope.formData), // pass in data as strings
                headers:
                {
                    'Content-Type': 'application/x-www-form-urlencoded'
                } // set the headers so angular passing info as form data (not request payload)
            })
            .success(function(data) {
                if (data.message.length) {
                    $scope.responseMsg = data.message;
                    $scope.responseCode = data.code;

                    $scope.enquiryForm.$setPristine();
                    $scope.init();
                }
            });
    }
};